import React from 'react';
import ReactPlayer from 'react-player';
import * as styles from './videoPlayer.module.scss';

interface IVideoPlayerProps {
  video: string;
  width?: string;
  playing?: boolean;
  loop?: boolean;
  controls?: boolean;
  showinfo?: number;
  muted?: boolean;
}

export const VideoPlayer = ({
  video,
  playing = true,
  loop = true,
  controls = true,
  showinfo = 0,
  muted = true,
  width = '100%',
}: IVideoPlayerProps) => {
  return (
    <div className={styles.mediaWrapper}>
      <ReactPlayer
        className={styles.videoPlayer}
        height="100%"
        width={width}
        url={video}
        muted={muted}
        playing={playing}
        loop
        controls={controls}
        config={{
          youtube: {
            playerVars: {
              showinfo,
              controls,
              autoplay: playing,
              loop,
              modestbranding: 1,
              disablekb: 1,
              allowFullScreen: 0,
            },
          },
          vimeo: {
            playerOptions: {
              iframeParams: { fullscreen: 0 },
              playsInline: false,
              controls: false,
            },
          },
        }}
        type="video/mp4"
      />
    </div>
  );
};
